(function () {
  var PDP_BODY_CLASS = 'template-product-quilt-product-new-pdp2026q2';
  var BUY_NOW_LABEL = 'Buy Now';

  function parseMoneyText(s) {
    if (s == null || s === '') return null;
    var n = parseFloat(String(s).replace(/[^0-9.-]+/g, ''));
    return isNaN(n) ? null : n;
  }

  /**
   * Reads the buy CTA price strip after theme + optional SKU discount (custom.js) DOM updates.
   * Variant JSON alone is wrong when an active SKU discount code adjusts the displayed sale price in the box.
   */
  function readBuyCtaSaleAndCompare() {
    var card = document.querySelector('.pdp2026-buy-cta');
    if (!card) return null;
    var wrap = card.querySelector('.pdp2026-buy-cta__price');
    if (!wrap) return null;
    // SKU discount (custom.js) sets priceNum.textContent on .price__number, which removes .money — read fallbacks.
    var saleEl =
      wrap.querySelector('.price__number .money') || wrap.querySelector('.price__number');
    var cmpEl =
      wrap.querySelector('.price__compare .money') ||
      wrap.querySelector('s.price__compare, strike.price__compare, .price__compare');
    var sale = saleEl ? parseMoneyText(saleEl.textContent) : null;
    var cmp = cmpEl ? parseMoneyText(cmpEl.textContent) : null;
    return { sale: sale, compare: cmp };
  }

  function dollarsToShopifyCents(dollars) {
    return Math.round(dollars * 100);
  }

  function initPdp2026BuyCtaCallout() {
    var calloutEl = document.querySelector('[data-pdp2026-buy-cta-callout]');
    var vr = document.querySelector('variant-radios');
    if (!vr || !calloutEl || typeof Shopify === 'undefined') return;

    var moneyFormat =
      window.theme && window.theme.money_format ? window.theme.money_format : '${{amount}}';

    function updateCalloutFromDom() {
      var p = readBuyCtaSaleAndCompare();
      if (!p || p.sale == null) {
        calloutEl.textContent = 'Best price on your quilt';
        calloutEl.setAttribute('data-state', 'standard');
        calloutEl.classList.add('pdp2026-buy-cta__callout--muted');
        return;
      }
      if (p.compare != null && p.compare > p.sale) {
        var saveDollars = p.compare - p.sale;
        var pct =
          p.compare > 0
            ? Math.round((saveDollars * 100) / p.compare)
            : 0;
        calloutEl.textContent =
          'SAVE ' +
          Shopify.formatMoney(dollarsToShopifyCents(saveDollars), moneyFormat) +
          ' (' +
          pct +
          '%) TODAY!';
        calloutEl.setAttribute('data-state', 'sale');
        calloutEl.classList.remove('pdp2026-buy-cta__callout--muted');
      } else {
        calloutEl.textContent = 'Best price on your quilt';
        calloutEl.setAttribute('data-state', 'standard');
        calloutEl.classList.add('pdp2026-buy-cta__callout--muted');
      }
    }

    function scheduleCalloutSync() {
      setTimeout(updateCalloutFromDom, 0);
    }

    function syncBuyNowLabel(variant) {
      if (!document.body.classList.contains(PDP_BODY_CLASS)) return;
      if (!variant || !variant.available) return;
      var form = vr.closest('form');
      if (!form) return;
      if (form.querySelector('[name="add"].pdp-pill-cta--buy')) return;
      var labelSpan = form.querySelector('[name="add"] .js-product-add-text');
      if (labelSpan) labelSpan.textContent = BUY_NOW_LABEL;
    }

    vr.addEventListener('variants:change', function (e) {
      var variant = e.detail && e.detail.variant;
      syncBuyNowLabel(variant);
      scheduleCalloutSync();
    });

    scheduleCalloutSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdp2026BuyCtaCallout);
  } else {
    initPdp2026BuyCtaCallout();
  }
})();
